module.exports = __webpack_public_path__ + "img/banner01.27da548c.webp";